import PhotosSearcher from "./PhotosSearcher";

const FilterSection = ({
  filters,
  handleFiltersChange,
}: {
  filters: any;
  handleFiltersChange: (new_filters: any) => void;
}) => {
  return (
    <div className=" rounded-md">
      <PhotosSearcher initialFilters={filters} onSearch={handleFiltersChange} />
    </div>
  );
};
export default FilterSection;
